import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { BsExclamationTriangleFill } from "react-icons/bs";
import "./ResetProgressModal.scss";

type ResetProgressModalProps = {
  show: boolean;
  onHide: () => void;
  scope: "subject" | "module";
  targetName?: string;
  onConfirm: () => void | Promise<void>;
  isResetting?: boolean;
};

const ResetProgressModal = ({
  show,
  onHide,
  scope,
  targetName,
  onConfirm,
  isResetting = false,
}: ResetProgressModalProps) => {
  const title =
    scope === "subject" ? "Reset subject progress?" : "Reset module progress?";

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="reset-progress-modal"
    >
      <Modal.Header closeButton closeLabel="Close">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="reset-progress-modal__alert">
          <BsExclamationTriangleFill
            className="reset-progress-modal__icon"
            aria-hidden
          />
          <div>
            <p className="reset-progress-modal__lead">
              {targetName ? (
                <>
                  You are about to reset progress for{" "}
                  <strong>{targetName}</strong>.
                </>
              ) : (
                <>You are about to reset your progress.</>
              )}
            </p>
            <p className="reset-progress-modal__text">
              This works as if you are starting this {scope} from scratch.
            </p>
          </div>
        </div>

        <ul className="reset-progress-modal__list">
          <li>Your questions done count will be zeroed out</li>
          <li>Your average score will be zeroed out</li>
          <li>Starred questions will remain starred</li>
          <li>Flagged questions will remain flagged</li>
        </ul>

        <p className="reset-progress-modal__note">
          <strong>Note:</strong> recent activity on the Usage Stats page may
          still show your historic practice for reference.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isResetting}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={isResetting}>
          {isResetting ? "Resetting…" : "Reset progress"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ResetProgressModal;
